import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
// Lazily loaded like SignUpModal (see addRegistrationTerms): patched by
// path, once its chunk loads - the type-only import above is erased.
const LOG_IN_MODAL = 'flarum/forum/components/LogInModal';

/**
 * The 429 of ThrottleFailedLogIns (too many failed log-ins from this
 * address): core's generic "going a little too quickly, try again in a few
 * seconds" would be wrong by a quarter of an hour - the block lasts until
 * 15 min after the first failure.
 */
export default function addLogInThrottleMessage() {
  override(LOG_IN_MODAL, 'onerror', function (original, error) {
    if (error.status === 429 && error.alert) {
      error.alert.content = app.translator.trans('champis-users.forum.log_in.too_many_failures');
    }
    original(error);
  });
}